import React from 'react';
import { Typography, Image, Row, Col, Divider } from 'antd';
import { styles } from '../../../styles';
import RelatedBlog from './RelatedBlogs';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '../../../hooks/MediaQuery.hook';
import { DEFAULT_LEAGUE_LINK } from '../../../utils/constant';
import BlogFooter from '../../../components/BlogFooter';

const { Title, Paragraph } = Typography;

export default function Blog3() {
  const matches = useMediaQuery('(min-width: 768px)');

  
  return (
    <>
    <Row style={styles.navLinks}>        
      <p><Link to={'/'}>Home</Link> / <Link to={'/blogs'}>Blogs </Link>/ Key Players Lighting Up the Stage<span></span></p>
    </Row>
    <Row justify="center">
      <Col xs={24} sm={22} md={20} lg={16}>
        <div
        style={styles.blogContainer}
        >
          <Typography>
            <Title level={2} style={{...styles.mainHeading, fontSize: !matches ? '24px': ''}}>
            Key Players Lighting Up the Stage
            </Title>
            <Paragraph style={styles.blogParagraph}>
            As always, the <Link to={DEFAULT_LEAGUE_LINK}>Premier League</Link> has been a showcase for the world’s best talents. Jude Bellingham has been one of the standout players for <a target='_blank' rel="noreferrer" href="https://www.realmadrid.com/">Real Madrid</a>, continuing his incredible development as one of Europe’s top midfielders. His goals and leadership have been crucial for Madrid’s early success.
            </Paragraph>
            <Paragraph style={styles.blogParagraph}>
            <a target='_blank' rel="noreferrer" href="https://www.transfermarkt.com/harry-kane/profil/spieler/132098/">Harry Kane</a>, now at Bayern Munich, has looked every bit the elite striker the Bavarians hoped for when they signed him in the summer. His goal-scoring exploits have kept Bayern among the favorites for the title.
            </Paragraph>

          <Image
            preview={false}
              src="https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/Champions-League.webp" // Replace with a relevant image URL
              alt="Key Football Players"
              style={{ borderRadius: '8px', width: '75%', margin: '10px' }}
            />
            <Paragraph style={styles.blogParagraph}>
            At <a href="https://koostream.live/fixtures/team/Manchester%20City">Manchester City</a>, Erling Haaland has continued his record-breaking form in front of goal, with his physicality and finishing making him one of the most feared players in Europe.
            </Paragraph>
            <Paragraph style={styles.blogParagraph}>
            Other players, like Barcelona’s Pedri, Napoli’s Victor Osimhen, and Arsenal’s Bukayo Saka, have also made waves, contributing both goals and assists while proving themselves as the future stars of European football.
            </Paragraph>

            <Title level={4} style={styles.blogHeading}>What Lies Ahead</Title>
            <Paragraph style={styles.blogParagraph}>
            With the group stages nearing their conclusion, attention will soon turn to the knockout rounds, where the intensity ratchets up even further. Fans can expect some blockbuster clashes, with many of Europe’s elite clubs poised to advance to the Round of 16. However, as this season has already shown, nothing is certain in the <Link to={DEFAULT_LEAGUE_LINK}>Premier League</Link>, and surprises could be lurking around the corner.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            Will <a target='_blank' rel="noreferrer" href="https://www.realmadrid.com/">Real Madrid</a> retain their crown and cement their dominance in Europe? Can Real Madrid continue their incredible Champions League legacy? Or will a new champion emerge from the shadows? The <Link to={DEFAULT_LEAGUE_LINK}> 2024/25 Premier League</Link> promises more excitement as Europe’s best battle for the ultimate prize in club football.
            </Paragraph>

            <Title level={4} style={styles.blogHeading}>Conclusion</Title>
            <Paragraph style={styles.blogParagraph}>
            The 2024/2025 <a target='_blank' rel="noreferrer" href="https://www.uefa.com/uefachampionsleague/">UEFA Champions League</a> season has been nothing short of captivating, delivering memorable performances, unexpected upsets, and the emergence of rising stars alongside the seasoned legends. As we move from the group stages to the knockout rounds, anticipation only grows for what lies ahead.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            With elite teams gearing up for high-stakes clashes and players reaching new heights in skill and determination, the road to the final promises to be thrilling and unpredictable. Whether a perennial powerhouse or a dark horse takes home the trophy, one thing is certain: this <a  href="https://koostream.live/fixtures/league/UEFA Champions League">UEFA Champions League</a> season will be one to remember.
            </Paragraph>

            <Divider></Divider>

            <Title level={4} style={{...styles.blogHeading, textAlign: 'start', fontSize: '18px' }}>
              Read More Below
            </Title>
            <div style={{paddingRight: '10px'}}>
              <RelatedBlog excludedId={3}></RelatedBlog>
            </div>

            <BlogFooter />
          </Typography>
        </div>
      </Col>
    </Row>
    </>
  );
}

